import { Check } from "lucide-react";

export function Field({ label, id, required, children, hint }) {
  return (
    <div>
      <label htmlFor={id} className="label">{label}{required && <span className="text-red7"> *</span>}</label>
      {children}
      {hint && <p className="text-xs text-muted7 mt-1.5">{hint}</p>}
    </div>
  );
}

export function Input({ id, testid, ...p }) {
  return <input id={id} className="field" data-testid={testid || id} {...p} />;
}

export function Pills({ options, value, onChange, multi = true, testid = "pill", dark = false }) {
  const toggle = (o) => {
    if (!multi) return onChange(o);
    onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  };
  return (
    <div className="flex flex-wrap gap-2" role="group">
      {options.map((o) => {
        const on = multi ? value.includes(o) : value === o;
        return (
          <button type="button" key={o} onClick={() => toggle(o)} aria-pressed={on} data-testid={`${testid}-${o.toLowerCase().replace(/\s+/g, "-")}`}
            className={`min-h-[44px] px-4 border text-sm font-medium transition-colors duration-200 inline-flex items-center gap-2 ${on ? "bg-ink text-white border-ink" : dark ? "border-white/30 text-white hover:border-gold" : "border-tanline bg-white hover:border-ink"}`}>
            {on && <Check className="w-3.5 h-3.5 text-gold" />}{o}
          </button>
        );
      })}
    </div>
  );
}

export function Consent({ checked, onChange, testid = "consent-checkbox" }) {
  return (
    <label className="flex items-start gap-3 text-xs text-muted7 leading-relaxed cursor-pointer">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 w-5 h-5 accent-[#111] shrink-0" data-testid={testid} required />
      <span>By checking this box, I agree that Se7en Capital Group may call and text me at the number provided about my request, including by automated means. Consent is not a condition of purchase. Message and data rates may apply. Reply STOP to opt out.</span>
    </label>
  );
}

export function FormError({ msg }) {
  if (!msg) return null;
  return <p className="text-sm bg-[#F6E2E3] text-[#8A1F2A] px-4 py-3" role="alert" data-testid="form-error">{msg}</p>;
}
